<template>
    <button
        v-tippy="t('editorDeleteTable')"
        :class="[buttonState(editor.can().deleteTable()), 'flex-none rounded p-1 text-sm']"
        :disabled="!editor.can().deleteTable()"
        @click="editor.chain().focus().deleteTable().run()"
    >
        <MdiTableRemove class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiTableRemove from 'materialdesignicons-vue3/icons/MdiTableRemove.js';

    defineExpose({
        name: 'DeleteTableButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
